import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";

import { setBreadcrumb } from "../actions/common";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

const styles = {
  text: {
    padding: "50px",
    margin: 0,
  },
};

const WorkInProgress = (props) => {
  if (props.match && props.match.params) {
    if (props.match.params.id) {
      props.dispatch(
        setBreadcrumb([
          {
            name: props.match.params.id,
          },
        ])
      );
    } else if (props.match.params.id2) {
      props.dispatch(
        setBreadcrumb([
          { name: "admin", display: false },
          { name: I18n.get("sidebar_" + props.match.params.id2) },
        ])
      );
    }
  } else {
    props.dispatch(setBreadcrumb([]));
  }

  const { classes } = props;
  return (
    <Grid container direction="column" className="height-100">
      <Grid item xs className="mainContainer">
        <Box className="mainContent">
          <Box className={classes.text}>
            <h2>Work in progress</h2>
            <p>
              This functionality is not currently implemented. Please come back
              soon.
            </p>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default connect()(withStyles(styles)(WorkInProgress));
